import './VolumeSlider.scss'

import React, { useEffect, useRef } from 'react'
import { useSlider } from 'react-use'
import SimpleSlider from '../reactSlider'
import { UPDATE_AUDIO_VOLUME, usePlayer } from '../../context/player-context'
import cn from 'classnames'

function VolumeSlider({ className = '' }) {
  const { contextState, dispatch } = usePlayer()

  const volumeRef = useRef(null)
  const { value, isSliding } = useSlider(volumeRef)

  const getRoundedValue = (percent = 100) =>
    Math.floor(contextState.audioVolume * percent)

  useEffect(() => {
    if (isSliding) {
      dispatch({ type: UPDATE_AUDIO_VOLUME, payload: value })
      contextState.audioControls.volume(value)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  return (
    <div className='audio-volume--container d-flex flex-column gap-2 align-items-start mb-sm-5 px-sm-3 py-sm-2'>
      <span>Volume</span>
      <div className='w-100 d-flex gap-3 align-items-center'>
        <button className='bg-transparent border-0 fs-4'>
          <i className='bi bi-volume-up'></i>
        </button>
        <div
          className={cn('volume-slider position-relative w-100 ', className)}
        >
          <span
            className='volume-slider__value position-absolute d-sm-none'
            style={{
              left: `${getRoundedValue(92)}%`
            }}
          >
            {getRoundedValue()}%
          </span>
          <SimpleSlider sliderRef={volumeRef} sliderValue={getRoundedValue()} />
        </div>
      </div>
    </div>
  )
}

export default React.memo(VolumeSlider)
